__turbopack_context__.v({
  "container": "styles-module__gwohnW__container",
});
